<div class="row-no-margin" style="padding:10px;">
  <div style="padding:10px;" class="row-no-margin col-md-12 ">
    <mat-form-field appearance="fill" floatLabel="always" style="width:25%;padding-right:5px;">
      <mat-label>Fee:</mat-label>
      <input matInput class="mat-focused" placeholder="Fee:" [(ngModel)]="CurrentFee.FeeName" />
    </mat-form-field>
    <!--<input name="FeeName" placeholder="Name" class="smallInput smallMargin align-content-center" style="width:20%;" [(ngModel)]="CurrentFee.FeeName" />-->
    <mat-form-field appearance="fill" floatLabel="always" style="width: 50%; padding-right: 5px;">
      <mat-label>Description:</mat-label>
      <input matInput class="mat-focused" placeholder="Description:" [(ngModel)]="CurrentFee.Description" />
    </mat-form-field>
    <!--<input [(ngModel)]="CurrentFee.Description" placeholder="Description" style="width:40%;" />-->
    <mat-form-field appearance="fill" floatLabel="always" style="width: 10%; padding-right: 5px;">
      <mat-label>Qty:</mat-label>
      <input matInput class="mat-focused" placeholder="Qty:" [(ngModel)]="CurrentFee.Qty" />
    </mat-form-field>
    <!--<input name="FeeQty" placeholder="Qty" class="smallInput smallMargin align-content-center" style="width:10%;" [(ngModel)]="CurrentFee.Qty" />-->
    <mat-form-field appearance="fill" floatLabel="always" style="width:15%;">
      <mat-label>Price:</mat-label>
      <input matInput class="mat-focused" placeholder="Price:" [ngModel]="CurrentFee.UnitPrice | currency" [ngModelOptions]="{updateOn:'blur'}"  (ngModelChange)="AssignFeePrice($event)" />
    </mat-form-field>
    <!--<input name="FeePrice" placeholder="Price" class="smallInput smallMargin align-content-center" style="width:10%;" [(ngModel)]="CurrentFee.UnitPrice" />-->
  </div>

  <div class="row-no-margin col-md-12 justify-content-center">
    <!--buttons-->
    <button class="blue" (click)="AddFee()">Save</button>&nbsp;
    <button class="blue" (click)="CloseWindow()">Close</button>
  </div>
</div>
